import * as customerVehiclesServices from './customerVehiclesServices';

export { customerVehiclesServices };
